/* eslint-disable react/display-name */
import { LoadingSpinnerBranded, ASOSIcon } from '@cof/plastic-components';

import { BRANDS } from '../../utilities/constants';

export default (props) => <LoadingSpinnerBranded {...props} brandConfig={{ asos: ASOSIcon }} allowList={BRANDS} />;
